import { createContext, useContext } from 'react';

export const MY_DASHBOARD_LABEL = 'My Dashboard';

/** Who's looking at the landing page, as far as its buttons care. */
export type Viewer = {
	isLoggedIn: boolean;
	/** An approved creator, i.e. has a dashboard. */
	isCreator: boolean;
};

export const SIGNED_OUT_VIEWER: Viewer = {
	isLoggedIn: false,
	isCreator: false,
};

const ViewerContext = createContext<Viewer>(SIGNED_OUT_VIEWER);

/** Filled from the landing route's loader, so the server-rendered page already knows. */
export const ViewerProvider = ViewerContext.Provider;

export const useViewer = () => useContext(ViewerContext);
